import { create, fromJson, toJson, type JsonValue } from '@bufbuild/protobuf';
import { apiClient } from './request';
import { type ListRequest, ListRequestSchema } from '@/proto/agentplatform/httpv2/common_pb';
import { type RAG, type RAGClass } from '@/proto/agentplatform/v1/rag_pb';
import {
  ListRAGClassesResponseSchema,
  CreateRAGClassRequestSchema,
  CreateRAGClassResponseSchema,
  GetRAGClassRequestSchema,
  GetRAGClassResponseSchema,
  UpdateRAGClassRequestSchema,
  UpdateRAGClassResponseSchema,
  DeleteRAGClassRequestSchema,
  ListRAGsResponseSchema,
  CreateRAGRequestSchema,
  CreateRAGResponseSchema,
  GetRAGRequestSchema,
  GetRAGResponseSchema,
  UpdateRAGRequestSchema,
  UpdateRAGResponseSchema,
  DeleteRAGRequestSchema,
} from '@/proto/agentplatform/httpv2/rag_pb';

async function sendV2(path: string, body: JsonValue): Promise<JsonValue> {
  const resp = await apiClient.post<JsonValue>(path, body);
  return resp.data;
}

export const ragPluginApi = {
  listRAGClasses: async (params: ListRequest) => {
    const raw = await sendV2('/v2/ListRAGClasses', toJson(ListRequestSchema, params));
    const resp = fromJson(ListRAGClassesResponseSchema, raw);
    return { data: resp.data?.items ?? [], total: resp.data?.total ?? 0 };
  },

  createRAGClass: async (payload: RAGClass): Promise<RAGClass> => {
    const req = create(CreateRAGClassRequestSchema, { ragClass: payload });
    const raw = await sendV2('/v2/CreateRAGClass', toJson(CreateRAGClassRequestSchema, req));
    return fromJson(CreateRAGClassResponseSchema, raw).data!;
  },

  getRAGClass: async (id: string): Promise<RAGClass> => {
    const req = create(GetRAGClassRequestSchema, { id });
    const raw = await sendV2('/v2/GetRAGClass', toJson(GetRAGClassRequestSchema, req));
    return fromJson(GetRAGClassResponseSchema, raw).data!;
  },

  updateRAGClass: async (id: string, payload: RAGClass): Promise<RAGClass> => {
    const req = create(UpdateRAGClassRequestSchema, { id, ragClass: payload });
    const raw = await sendV2('/v2/UpdateRAGClass', toJson(UpdateRAGClassRequestSchema, req));
    return fromJson(UpdateRAGClassResponseSchema, raw).data!;
  },

  deleteRAGClass: async (id: string): Promise<void> => {
    const req = create(DeleteRAGClassRequestSchema, { id });
    await sendV2('/v2/DeleteRAGClass', toJson(DeleteRAGClassRequestSchema, req));
  },

  listRAGs: async (params: ListRequest) => {
    const raw = await sendV2('/v2/ListRAGs', toJson(ListRequestSchema, params));
    const resp = fromJson(ListRAGsResponseSchema, raw);
    return { data: resp.data?.items ?? [], total: resp.data?.total ?? 0 };
  },

  createRAG: async (payload: RAG): Promise<RAG> => {
    const req = create(CreateRAGRequestSchema, { rag: payload });
    const raw = await sendV2('/v2/CreateRAG', toJson(CreateRAGRequestSchema, req));
    return fromJson(CreateRAGResponseSchema, raw).data!;
  },

  getRAG: async (id: string): Promise<RAG> => {
    const req = create(GetRAGRequestSchema, { id });
    const raw = await sendV2('/v2/GetRAG', toJson(GetRAGRequestSchema, req));
    return fromJson(GetRAGResponseSchema, raw).data!;
  },

  updateRAG: async (id: string, payload: RAG): Promise<RAG> => {
    const req = create(UpdateRAGRequestSchema, { id, rag: payload });
    const raw = await sendV2('/v2/UpdateRAG', toJson(UpdateRAGRequestSchema, req));
    return fromJson(UpdateRAGResponseSchema, raw).data!;
  },

  deleteRAG: async (id: string): Promise<void> => {
    const req = create(DeleteRAGRequestSchema, { id });
    await sendV2('/v2/DeleteRAG', toJson(DeleteRAGRequestSchema, req));
  },
};
